/**
 * 描述：租户管理
 * 日期：2017-7-21
 * 作者：jiang.weiwei
 */
'use strict';
angular.module('tManageMentModule', ['tManageMentServiceModule', 'checkNameRepeatedModule'])
    .controller('tManageMentCtrl', ['$scope', 'trsspliceString', '$q', '$filter', 'tManageMentService', 'modalDialog', 'trsHttpService', function($scope, trsspliceString, $q, $filter, tManageMentService, modalDialog, trsHttpService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         */
        function initStatus() {
            $scope.status = {

            };
            $scope.params = {
                'serviceid': 'mlf_tenant',
                'methodName': 'queryTenants',
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20
            };
            $scope.data = {
                selectedArray: [],
                tenants: []
            };
        }

        /**
         * [initData description]初始化数据
         */
        function initData() {
            initDropDownList();
            requestData();
        }

        /**
         * [initDropDownList description]初始化下拉菜单
         */
        function initDropDownList() {
            $scope.status.statusList = [{ name: '全部' }, { name: '启用', value: 0 }, { name: '停用', value: 1 }];
            $scope.status.selectedStatus = angular.copy($scope.status.statusList[0]);
            $scope.status.searchType = [
                { name: '检索条件', value: 'SEARCHVALUE' },
                { name: '租户ID', value: 'TENANTID' },
                { name: '租户名称', value: 'TENANTNAME' },
                { name: '简介', value: 'ABBREVIATION' },
                { name: '描述', value: 'DESCRIPTION' },
                { name: '机构代码', value: 'ORGCODE' },
                { name: '备注', value: 'MEMO' }
            ];
            // 选中第一个 copy复刻
            $scope.status.selectedSearchType = angular.copy($scope.status.searchType[0]);
            getTenantType().then(function(data) {
                $scope.status.tenantType = data;
                $scope.status.selectedTenantType = angular.copy($scope.status.tenantType[0]);
            });
        }

        /**
         * [getTenantType description]企业类型初始化下拉菜单
         */
        function getTenantType() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_tenant',
                methodname: 'findIndustryByConfig',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                for (var i = 0; i < data.length; i++) {
                    data[i] = { name: data[i], value: data[i] };
                }
                data.unshift({ name: '全部' }); // 添加
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [hotWarning description]资源使用限制
         * @return {[type]} [description]
         */
        $scope.resouceLimit = function(){
            tManageMentService.resouceLimit().then(function(){

            });

        };

        /**
         * [hotWarning description]地区相关官员
         * @return {[type]} [description]
         */
        $scope.regionalOfficia = function(){
            tManageMentService.regionalOfficia().then(function(){

            });

        };

        /**
         * [createUser description]新建
         */
        $scope.TenantNewUser = function() {
            tManageMentService.tenantCreate().then(function(params) {
                params.serviceid = 'mlf_tenant';
                params.methodname = 'initTenantGrpUser';
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('新建租户成功', '', 'success', false);
                    $scope.page.CURRPAGE = 1;
                    requestData();
                });
            }, function(data) {
                // 失败
            });
        };

        /**
         * [disable description]停用
         */
        $scope.TenantDisable = function() {
            var ids = trsspliceString.spliceString($scope.data.selectedArray, 'TENANTID', ',', 'STATUS', '0');
            disable(ids);
        };

        /**
         * [tenant searchWord description] 点击搜索
         */
        $scope.searchWord = function() {
            var searchType;
            for (var i = 0; i < $scope.status.searchType.length; i++) {
                searchType = $scope.status.searchType[i].value;
                delete $scope.params[searchType];
            }
            $scope.params[$scope.status.selectedSearchType.value] = $scope.status.searchWord;
            requestData();
        };

        /**
         * [disable description] tenant请求数据
         */
        function requestData() {
            var defer = $q.defer();
            $scope.data.selectedArray = [];
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                // tenant请求数据user
                $scope.data.tenants = data.DATA;
                $scope.page = data.PAGER;
                $scope.data.copyCurrPage = data.PAGER.CURRPAGE;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [disable description] tenant请求数据
         */
        $scope.requestData = function() {
            requestData();
        };

        /**
         * [tenant selectItem description] 选中下拉菜单
         * @param {[string]} [attribute1] [description]
         * @param {[string]} [attribute2] [description]
         */
        $scope.selectFilterType = function(attribute1, attribute2) {
            $scope.params[attribute2] = $scope.status[attribute1].value;
            requestData();
        };

        /**
         * [tenantJumpToPage description] 跳转到指定页
         * @param {[string]} [attribute1] [description]
         * @param {[string]} [attribute2] [description]
         * tenant
         */
        $scope.jumpToPage = function() {
            $scope.params.CURRPAGE = $scope.data.copyCurrPage;
            requestData();
        };

        /**
         * [selectItem description] 选中租户
         * @param {[object]} [item] [description] 选中租户
         */
        $scope.selectItem = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {$scope.data.selectedArray.push(item);} else {$scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);}
        };

        /**
         * [selectAll description] 全选租户
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.data.tenants.length ? [] : (function() {
                var array = [];
                for (var i = 0; i < $scope.data.tenants.length; i++) {
                    array.push($scope.data.tenants[i]);
                }
                return array;
            })();
        };

        /**
         * [disable description] 停用租户
         * @param {[string]} [ids] [description] id串
         */
        function disable(ids) {
            if (!ids) {
                modalDialog.alertType('您选择的租户都已停用', '', 'info', false);
                return;
            }
            modalDialog.alertType('确定停用？', '', 'info', true, function() {
                var params = {
                    serviceid: 'mlf_tenant',
                    methodname: 'deactivateTenant',
                    ObjectIds: ids
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.multiReportsAlert(data, function() {
                        $scope.page.CURRPAGE = 1;
                        requestData();
                    });
                });
            });
        }

        /**
         * [installTenant description]
         * @return {[type]} [description]
         */
        $scope.installTenant = function() {
            
        };

        /**
         * [selectItem description] 选中租户
         * @param {[object]} [item] [description] 选中租户
         */
        $scope.editTenant = function(item) {
            $scope.data.fromDate = item.CRTIME;
            $scope.data.untilDate = item.ENDTIME;
            tManageMentService.editTenant(angular.copy(item)).then(function(params) {
                delete params.CRTIME;
                delete params.CRUSER;
                params.ObjectId = params.TENANTID;
                delete params.TENANTID;
                params.serviceid = 'mlf_tenant';
                params.methodname = 'updateTenantInfo';

                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('编辑企业成功', '', 'success', false);
                    $scope.page.CURRPAGE = 1;
                    requestData();
                });
            });
        };


        /**
         * [dateFormat description] 格式化时间
         * @param {[object]} [item] [description] 选中租户
         */
        $scope.dateFormat = function(item) {
            item.CRTIME = $filter('date')(Date.parse(item.CRTIME), 'yyyy-MM-dd');
            item.ENDTIME = $filter('date')(Date.parse(item.ENDTIME), 'yyyy-MM-dd');
        };
    }]);
